const isEmpty = collection =>
  Object.keys(collection).length === 0;

export default isEmpty;
